const initialState = {};

export const sellerRegReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SELLER_REG":
      return action.payload;
    default:
      return state;
  }
};

export const sellerRegReducer2 = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SELLER_REG2":
      return action.payload;
    default:
      return state;
  }
};
